module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card-body', [_c('div', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Enquiry For Pricing List")]), _vm._v(" "), _c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AddLead()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('FilterCBModal')], 1)], 1), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.debounceSearch
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "hours"
    }
  }, [_vm._v("Hours")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.hoursStatusList,
      "id": "hours",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Select Hours"
    },
    on: {
      "input": function($event) {
        _vm.debounceSearch();
        _vm.getCurrentLastDate();
        _vm.getTimeHours();
      }
    },
    model: {
      value: (_vm.Filter.hours),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "hours", $$v)
      },
      expression: "Filter.hours"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Start Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.startDate ? false : true,
      "type": "time",
      "locale": "en"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.startTime),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "startTime", $$v)
      },
      expression: "Filter.startTime"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("End Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.endDate ? false : true,
      "type": "time",
      "locale": "en"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.endTime),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "endTime", $$v)
      },
      expression: "Filter.endTime"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "id": "StatusType",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Select Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.StatusType),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "StatusType", $$v)
      },
      expression: "Filter.StatusType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Created By")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Updated By")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "updatedByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Updated User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.updatedByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "updatedByFilter", $$v)
      },
      expression: "Filter.updatedByFilter"
    }
  })], 1), _vm._v(" "), (_vm.Filter.StatusType == 'Normal') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Lead/Client\n                  "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientLeadList,
      "id": "lead_client_details",
      "option-value": "client_id",
      "option-text": "client_name",
      "placeholder": "Please Client/Lead Name"
    },
    on: {
      "input": function($event) {
        _vm.LeadCLientDetails(_vm.Filter.fk_lead_client_id)
      }
    },
    model: {
      value: (_vm.Filter.fk_lead_client_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_lead_client_id", $$v)
      },
      expression: "Filter.fk_lead_client_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "id": "shipment_type",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.shipment_type),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shipment_type", $$v)
      },
      expression: "Filter.shipment_type"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.moduelTypeList,
      "id": "shipment_type",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.transport_type),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transport_type", $$v)
      },
      expression: "Filter.transport_type"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.ContainerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerTypeFilter", $$v)
      },
      expression: "Filter.ContainerTypeFilter"
    }
  })], 1), _vm._v(" "), (_vm.Filter.shipment_type == 'Sea') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transport_type == 'Export' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_por_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_por_id", $$v)
      },
      expression: "Filter.fk_por_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Sea') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transport_type == 'Export' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_pol_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_pol_id", $$v)
      },
      expression: "Filter.fk_pol_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Sea') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transport_type == 'Export' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_pod_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_pod_id", $$v)
      },
      expression: "Filter.fk_pod_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Sea') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.transport_type == 'Export' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
        ],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_fpod_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_fpod_id", $$v)
      },
      expression: "Filter.fk_fpod_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Sea') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SLine")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_pre_shipping),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_pre_shipping", $$v)
      },
      expression: "Filter.fk_pre_shipping"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Air') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Airport of Departure (Handover)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirPortDepartureList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport of Departure"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_airportDeparture),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_airportDeparture", $$v)
      },
      expression: "Filter.fk_airportDeparture"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Air') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Airport of Destination")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirPortDestinationList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport of Destination"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_airportDestination),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_airportDestination", $$v)
      },
      expression: "Filter.fk_airportDestination"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Filter.shipment_type == 'Air') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Air Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirLineList'],
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Air Line"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.fk_airline_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_airline_id", $$v)
      },
      expression: "Filter.fk_airline_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Enq Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.EnqStatusList,
      "id": "EnqStatus",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Enq Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.EnqStatus),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "EnqStatus", $$v)
      },
      expression: "Filter.EnqStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Lead Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.common),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "common", $$v)
      },
      expression: "Filter.common"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('Enquiry_Price_Master_List', 'Export')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n                    "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.EnqPricingList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "enq_price_id"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "enq_price_id",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "enq_no",
      fn: function(row1) {
        return [(row1.item.enq_no) ? _c('span', [_vm._v(_vm._s(row1.item.enq_no))]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.RaisedFrom) ? _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.RaisedFrom))]) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row1) {
        return [(row1.item.typeClient) ? _c('span', [_vm._v("Type : " + _vm._s(row1.item.typeClient)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.lead_clinet_type) ? _c('span', [_vm._v("Lead/Client Type : " + _vm._s(row1.item.lead_clinet_type)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.clientName ||
          row1.item.open_client_name ||
          row1.item.lead_clinet_name
        ) ? _c('span', [_vm._v("\n                    " + _vm._s(row1.item.lead_clinet_name ?
          row1.item.lead_clinet_name :
          row1.item.clientName) + "\n\n                    "), _vm._v(" "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "POR",
      fn: function(row2) {
        return [(row2.item.ARDeparture) ? _c('span', [_vm._v("\n                    Airport of Departure (Handover) : " + _vm._s(row2.item.ARDeparture) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.ARDestination) ? _c('span', [_vm._v("\n                    Airport of Destination : " + _vm._s(row2.item.ARDestination) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.POR) ? _c('span', [_vm._v("\n                    POR : " + _vm._s(row2.item.POR) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.POL) ? _c('span', [_vm._v("\n                    POL : " + _vm._s(row2.item.POL) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.POD) ? _c('span', [_vm._v("\n                    POD : " + _vm._s(row2.item.POD) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.FPOD) ? _c('span', [_vm._v("\n                    FPOD : " + _vm._s(row2.item.FPOD) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.EmptyPL) ? _c('span', [_vm._v("\n                    EmptyPL : " + _vm._s(row2.item.EmptyPL) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.cargo_weight) ? _c('span', [_vm._v("\n                    Cargo Weight : " + _vm._s(row2.item.cargo_weight) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.moment_by) ? _c('span', [_vm._v("\n                    Movement by : " + _vm._s(row2.item.moment_by) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.transit_days) ? _c('span', [_vm._v("\n                    Transit Days : " + _vm._s(row2.item.transit_days) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.shipment_type) ? _c('span', [_vm._v("\n                    Shipment Type : " + _vm._s(row2.item.shipment_type) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.transport_type) ? _c('span', [_vm._v("\n                    Trasport Type : " + _vm._s(row2.item.transport_type) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_container_type) ? _c('span', [_vm._v("\n                    Container Type : " + _vm._s(row2.item.lead_container_type) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "SLine",
      fn: function(row4) {
        return [(row4.item.prefredShippingLine) ? _c('span', [_vm._v("\n                    Prefered Shipping Line :" + _vm._s(row4.item.prefredShippingLine) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.airlineName) ? _c('span', [_vm._v("\n                    Air Line :" + _vm._s(row4.item.airlineName) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.remarks) ? _c('span', [_c('b', [_vm._v("Remarks :")]), _vm._v(" " + _vm._s(row4.item.remarks)), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.multipleContainerType_New) ? _c('span', [_c('b', [_vm._v("Container Type :")]), _vm._v("\n                    " + _vm._s(row4.item.multipleContainerType_New))]) : _vm._e()]
      }
    }, {
      key: "is_active",
      fn: function(row3) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row3.item.enq_price_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.enq_price_id,
            "name": "approval",
            "value": row3.item.is_active == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row3.item.is_active == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row3.item.is_active == 1 ? "Active" : "In-Active"))])], 1)])], 1), _vm._v(" "), _c('br')]
      }
    }, {
      key: "created_at",
      fn: function(row3) {
        return [(row3.item.created_at) ? _c('span', [_vm._v("\n                    Created : " + _vm._s(row3.item.created_at) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.createdBy) ? _c('span', [_vm._v("\n                    Created By : " + _vm._s(row3.item.createdBy) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updated_at) ? _c('span', [_vm._v("\n                    Updated : " + _vm._s(row3.item.updated_at) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updatedBy) ? _c('span', [_vm._v("\n                    Updated By : " + _vm._s(row3.item.updatedBy) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editEnqPricing(row2.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$sessionsStorage.get("designation") != "Admin" &&
          _vm.$sessionsStorage.get("nameUser") != "Bhavneesh" ?
          "Update" :
          "View Enquiry Details"))]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editPricing(row2.item)
            }
          }
        }, [_vm._v("Details")]), _vm._v(" "), (row2.item.is_enq_closed == 1) ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.addBookingResp(row2.item)
            }
          }
        }, [_vm._v(_vm._s(row2.item.prbr_id <= 0 ? "Add" : "View") + " Booking Resp")]) : _vm._e(), _vm._v(" "), _c('div', {
          attrs: {
            "id": 'row' + row2.item.enq_price_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row2.item.enq_price_id,
            "name": "approval",
            "value": row2.item.is_enq_closed == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.EnquiryRunning(row2.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row2.item.is_enq_closed == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row2.item.is_enq_closed == 1 ? "Responded" : "Running"))])], 1)])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])])], 1)]), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4909973c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/enqPriceList.vue
// module id = 2592
// module chunks = 0